import { LEAD_SOURCE_CODES } from '../constants/leadSources.js';
import { LEAD_STATUSES } from '../constants/leadStatus.js';
import { EMAIL_VERIFICATION_STATUSES } from '../schemas/scraper.js';
import { LEGAL_BASIS_VALUES } from '../constants/legalBasis.js';
export const SEGMENT_OPS = [
    'eq',
    'neq',
    'in',
    'not_in',
    'contains',
    'exists',
    'not_exists',
];
/** UI + server allowlist (live / partial only). */
export const SEGMENT_FIELD_CATALOG = [
    {
        entity: 'lead',
        field: 'status',
        label: 'Leadstatus',
        availability: 'live',
        ops: ['eq', 'in'],
        valueType: 'enum',
        enumValues: LEAD_STATUSES,
    },
    {
        entity: 'lead',
        field: 'source',
        label: 'Bron',
        availability: 'live',
        ops: ['eq', 'in'],
        valueType: 'enum',
        enumValues: LEAD_SOURCE_CODES,
    },
    {
        entity: 'lead',
        field: 'tag',
        label: 'Tag',
        availability: 'live',
        ops: ['eq'],
        valueType: 'string',
    },
    {
        entity: 'lead',
        field: 'email',
        label: 'E-mail',
        availability: 'live',
        ops: ['exists', 'not_exists'],
        valueType: 'boolean',
    },
    {
        entity: 'lead',
        field: 'phone',
        label: 'Telefoon',
        availability: 'live',
        ops: ['exists', 'not_exists'],
        valueType: 'boolean',
    },
    {
        entity: 'lead',
        field: 'job_title',
        label: 'Functietitel',
        availability: 'partial',
        ops: ['contains', 'exists', 'not_exists'],
        valueType: 'string',
    },
    {
        entity: 'lead',
        field: 'linkedin_url',
        label: 'LinkedIn',
        availability: 'partial',
        ops: ['exists', 'not_exists'],
        valueType: 'boolean',
    },
    {
        entity: 'lead',
        field: 'email_verification_status',
        label: 'E-mail verificatie',
        availability: 'live',
        ops: ['eq', 'in'],
        valueType: 'enum',
        enumValues: EMAIL_VERIFICATION_STATUSES,
    },
    {
        entity: 'lead',
        field: 'do_not_contact',
        label: 'Niet benaderen',
        availability: 'live',
        ops: ['eq'],
        valueType: 'boolean',
    },
    {
        entity: 'lead',
        field: 'legal_basis',
        label: 'Rechtsgrond',
        availability: 'live',
        ops: ['eq', 'exists', 'not_exists'],
        valueType: 'enum',
        enumValues: LEGAL_BASIS_VALUES,
    },
    {
        entity: 'lead',
        field: 'company',
        label: 'Bedrijfsnaam (lead)',
        availability: 'live',
        ops: ['contains'],
        valueType: 'string',
    },
    {
        entity: 'account',
        field: 'industry',
        label: 'Branche (account)',
        availability: 'partial',
        ops: ['contains', 'eq'],
        valueType: 'string',
    },
    {
        entity: 'account',
        field: 'company_size',
        label: 'Bedrijfsgrootte',
        availability: 'partial',
        ops: ['contains', 'eq'],
        valueType: 'string',
    },
    {
        entity: 'account',
        field: 'domain',
        label: 'Domein',
        availability: 'live',
        ops: ['contains', 'exists', 'not_exists'],
        valueType: 'string',
    },
    {
        entity: 'account',
        field: 'account_name',
        label: 'Accountnaam',
        availability: 'live',
        ops: ['contains'],
        valueType: 'string',
    },
];
export function findSegmentFieldMeta(entity, field) {
    return SEGMENT_FIELD_CATALOG.find((f) => f.entity === entity && f.field === field);
}
//# sourceMappingURL=segmentFieldCatalog.js.map